import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const addMoneyDrop = (data: PropertyType): Promise<PropertyType> =>
	api.post('esa-tools/money-drop/create', mapEntityToApi(data), setConfig(data)).then((res) => {
		return { message: UPDATE_GAME_MESSAGE, game: res.data.data };
	});
